import RootStack from "./root";
import type RootStackParamList from "../types/navigation";
import {
    createNavigationContainerRef,
    type LinkingOptions,
    NavigationContainer,
    getStateFromPath
} from "@react-navigation/native";

const APP_URL = process.env.APP_URL || "https://app.gencmusiadkonya.org";

export const navigationRef = createNavigationContainerRef<RootStackParamList>();

const linking: LinkingOptions<RootStackParamList> = {
    prefixes: [
        "https://*.gencmusiadkonya.org",
        "https://app.musiad.org.tr",
        "https://*.musiad.org.tr",
        "http://localhost:3001",
        "http://localhost:3000",
        "gmcoremobile://",
        "localhost:3001",
        APP_URL
    ],
    config: {
        screens: {
            Common: {
                screens: {
                    AnnouncementRouter: "announcement/:announcementID?",
                    NewsRouter: "news/:newsID?",
                    FormRouter: "form/:formID"
                }
            }
        }
    },
    getStateFromPath: (path, options) => {
        const normalizedPath = path
            .replace(/^\/announcements(\/|$)/, "/announcement$1")
            .replace(/^\/duyurular(\/|$)/, "/announcement$1")
            .replace(/^\/duyuru(\/|$)/, "/announcement$1")
            .replace(/^\/haberler(\/|$)/, "/news$1")
            .replace(/^\/haber(\/|$)/, "/news$1");

        return getStateFromPath(normalizedPath, options);
    }
};

const Navigation = () => {
    return <NavigationContainer
        ref={navigationRef}
        linking={linking}
    >
        <RootStack/>
    </NavigationContainer>;
};
export default Navigation;
